
import Exception from "../models/exceptions/Exceptions.vue";

const exceptionRouter = {
  path: "/exception",
  name: "Exception",
  component: Exception,
  props: true
};

export default exceptionRouter;